import { render } from "./AccountConfirmation.vue?vue&type=template&id=28b8a3ff"
import script from "./AccountConfirmation.vue?vue&type=script&lang=js"
export * from "./AccountConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__